//import Vue from "vue";
import Header from "../components/Header";

import Thumbs from "../components/Thumbs";
import Banner from "../components/Banner.vue";
import Title from "../components/Wap/Title";
import Subtitle from "../components/Wap/Subtitle";
import Content from "../components/Wap/Content";

import File from "../components/Wap/File";
// import Card from "../components/Wap/Card";
import Original from "../components/Wap/Original";

import Comment from "../components/Wap/Comment";
import CommentList from "../components/Wap/CommentList";
import OriginSubtitle from "../components/Wap/OriginSubtitle";
import Card from "../../stempcore/src/core/components/common/Card.vue";

import { URLS, $subscriber, interact, ck } from "fire-wind-water";
import service from "../services/article";
import template from "../mixin/template";
import { articleId, browerType } from "../common/sbase";
import { isInWechatAuth, initJsSdk, agentType } from "@/../stempcore/src/sbase";
import { articleSettingInfo } from "../common/settingData";
import Cta from "../../stempcore/src/core/components/common/Cta.vue";
import URL from "../assets/conf/setting.json";

function mergeCurrentParams(targetUrl) {
  const currentSearch = window.location.search;
  if (!currentSearch) return targetUrl;
  const currentParams = new URLSearchParams(currentSearch.substring(1));
  const target = new window.URL(targetUrl, window.location.origin);
  currentParams.forEach(function(value, key) {
    target.searchParams.set(key, value);
  });
  return target.pathname + target.search + target.hash;
}

export default {
  name: "Article",
  mixins: [template],
  data() {
    return {
      isShowFile: false,
      isShowComment: false,
      title: "",
      isSetting: false,
      theme: "",
      articleInfo: {},
      globalUserId: "",
      sess: "",
      userInfo: "",
      markCode: "",
      taskId: "",
      tenantId: "",
      isMini: "",
      ctaObj: {
        objId: "",
        tenantId: "",
        moduleId: "26"
      }
    };
  },
  created() {
    this.isMini = URLS.getURL("isMini") || "";
    if (URLS.getURL("isSetting")) {
      this.isSetting = true;
      this.isShowFile = true;
      this.isShowComment = true;
      $subscriber.emit("article-info", articleSettingInfo);
      return;
    } else {
      window.$sk.loading.show("正在读取数据");
      window.$sk.template.module(this);
    }
    this.markCode = URLS.getURL("markCode") || URLS.getHash("markCode") || "";
    this.taskId =
      URLS.getURL("marketingTaskId") || URLS.getHash("marketingTaskId") || "";
  },
  methods: {
    skUserInit() {
      console.log("获取用户本地信息");
    },
    skUserEnd() {
      console.log("获取用户信息结束");
      const info = window.$sk.template.get();
      this.userInfo = window.$sk.template.get();
      console.log(info);
      this.schemaId = info.common.schemaId;
      //      this.instanceId = info.common.instanceId;
      this.tenantId = info.common.tenantId;
      this.sess = info.user.session;
      this.globalUserId = info.user.globalUserId;
      $subscriber.emit("user-info", info.user);
      //      this.contactInfo = info.user;
      //      this.moduleId = info.common.moduleId;
      //      this.getData();
      this.initConfig(URLS.getURL("configId"), this.tenantId);
      this.load();
    },
    skUserChange() {
      console.log("用户信息发生改变");
    },
    skLinkEnd(e) {
      console.log("跳转逻辑判断完毕");
      if (!e.isJump) {
        $subscriber.emit("article-info", this.articleInfo);

        if (
          ((parseInt(this.articleInfo.bindWeChatId) &&
            this.articleInfo.isCertified == "1" &&
            this.articleInfo.accountType == "1") ||
            (parseInt(this.articleInfo.authorisedWeChatId) &&
              this.articleInfo.authorisedType == 1)) &&
          interact.isWeChat &&
          (!this.userInfo.user.tokenInfo ||
            (!this.userInfo.user.tokenInfo.nickname &&
              !this.userInfo.user.tokenInfo.original &&
              !this.userInfo.user.tokenInfo.original.openid)) &&
          isInWechatAuth(this.tenantId)
        ) {
          //显授权并且没有nickName
          window.$sk.template.update({
            type: "auth",
            data: {
              weChatId:
                parseInt(this.articleInfo.bindWeChatId) ||
                this.articleInfo.authorisedWeChatId,
              scope:
                this.articleInfo.authorisedType == 1
                  ? "snsapi_userinfo"
                  : "snsapi_base"
            }
          });
        } else {
          if (this.checkDevice()) {
            this.browse();
            if (agentType() == "weChat") {
              this.initWeChatShare();
            } else if (agentType() == "wxWork") {
              initJsSdk(this.tenantId, () => {
                this.initWxWorkShare();
              });
            }
            if (
              !(
                this.articleInfo.useLinkUrl == "1" &&
                this.articleInfo.linkUrl !== ""
              )
            ) {
              window.$sk.loading.hide();
            }
          }
        }
      }
    },

    initWxWorkShare() {
      const url = URLS.removeSearchParam(
        window.location.href,
        "token",
        "retCode",
        "puzzleFlag"
      );
      const info = this.articleInfo;
      const shareInfo = {
        title: info.shareTitle || info.title, // 分享标题,
        desc: info.shareDesc || info.summary, // 分享描述,
        link:
          URL.weworkCustomerJumpUrl.replace("{$tenantId}", this.tenantId) +
          encodeURIComponent(url), //这里需要改
        imgUrl: info.shareImageRealPath
          ? "https:" + info.shareImageRealPath
          : "" // 分享图标
      };
      shareInfo.link = window.$swxsdk.urlAddChannel(shareInfo.link);
      window.wx.onMenuShareAppMessage({ ...shareInfo });
      window.wx.onMenuShareWechat({ ...shareInfo });
      window.wx.onMenuShareTimeline({ ...shareInfo });
    },

    initWeChatShare() {
      if (!interact.isWeChat) {
        return;
      }
      const url = URLS.removeSearchParam(
        window.location.href,
        "token",
        "retCode",
        "puzzleFlag"
      );

      const info = this.articleInfo;
      const shareInfo = {
        title: info.shareTitle || info.title, // 分享标题,
        desc: info.shareDesc || info.summary, // 分享描述,
        link: URLS.updateSearchParam(
          "return_url",
          encodeURIComponent(url),
          info.longUrlLink
        ),
        imgUrl: info.shareImageRealPath
          ? "https:" + info.shareImageRealPath
          : "" // 分享图标
      };
      window.$swxsdk.initWxSdk(
        { tenantId: info.tenantId },
        window.$sk.config.apiUrl
      );
      if (info.shareState == 0) {
        window.$swxsdk.on(
          "hideMenuList",
          {
            menuList: [
              "menuItem:share:appMessage",
              "menuItem:share:timeline",
              "menuItem:share:qq",
              "menuItem:share:weiboApp",
              "menuItem:share:facebook",
              "menuItem:share:QZone",
              "menuItem:copyUrl",
              "menuItem:openWithQQBrowser",
              "menuItem:openWithSafari"
            ]
          },
          function(result) {
            console.log(result);
          }
        );
        window.$swxsdk.on("hideOptionMenu");
      } else {
        window.$swxsdk.on("sharer", shareInfo);
        window.$swxsdk.on("sharer_friends", shareInfo);
      }
    },
    skAuthEnd(e) {
      this.userInfo.user.tokenInfo = e.tokenInfo;
      this.userInfo.user.openId = e.tokenInfo.original.openid;
      this.initWeChatShare();
      this.browse();
      if (
        !(this.articleInfo.useLinkUrl == "1" && this.articleInfo.linkUrl !== "")
      ) {
        window.$sk.loading.hide();
      }
    },
    load() {
      const param = {
        articleId: articleId,
        tenantId: this.tenantId,
        isScroll: 1,
        withStat: 1,
        withTag: 1
      };
      //获取文章信息
      service.getArticle(param).subscribe(data => {
        this.title = data.content.title + "";
        this.articleInfo = data.content;
        this.isShowComment = data.content.isAllowedComment == 1;
        this.isShowFile =
          data.content.fileIds && data.content.fileIds.length > 0;
        this.articleInfo.bindWeChatId = "0";
        this.ctaObj.objId = articleId;
        this.ctaObj.tenantId = this.tenantId;
        //微信授权这里有点逻辑
        //1 wechatId 不为0的时候是实例下的微信号
        //2 attachWXAccount 没用
        //3 authorisedType 1 显授权   authorisedWeChatId 授权的微信号 是服务号
        //4 wehcatId 优先级高于 authorisedWeChatId
        //5 wechatId不为0是的时候 需要调用接口获取里绑定的wechatId是用来授权的（有订阅号绑定的情况，如果wechatId是服务号 则wechatId和绑定的wechatId是一致的）
        if (this.articleInfo.weChatId && this.articleInfo.weChatId != "0") {
          service
            .getAppId({
              weChatId: this.articleInfo.weChatId,
              wechatId: this.articleInfo.weChatId
            })
            .subscribe(data => {
              this.articleInfo.bindWeChatId = data.content.weChatId; //获取用来授权的微信号
              this.articleInfo.accountType = data.content.accountType;
              this.articleInfo.isCertified = data.content.isCertified;
              window.$sk.template.update({
                type: "link",
                data: {
                  identity: this.articleInfo.identity,
                  weChatId: "",
                  skObjectType: "article",
                  skObjectId: this.articleInfo.articleId,
                  meetingInstanceId: this.articleInfo.instanceId,
                  meetingType: 0,
                  memberFormId: this.articleInfo.registerFormId
                }
              });
            });
        } else {
          window.$sk.template.update({
            type: "link",
            data: {
              identity: this.articleInfo.identity,
              weChatId: this.articleInfo.weChatId,
              skObjectType: "article",
              skObjectId: this.articleInfo.articleId,
              meetingInstanceId: this.articleInfo.instanceId,
              meetingType: 0,
              memberFormId: this.articleInfo.registerFormId
            }
          });
        }

        //
      });
    },

    checkDevice() {
      //素材没有PC模板 要求PC端也能打开
      if (window.location.href.toLocaleLowerCase().indexOf("origin") > 0) {
        return true;
      }
      console.log(browerType, location.href.indexOf("wap") > 0);
      if (
        browerType == "pc" &&
        location.href.indexOf("wap") > 0 &&
        window.navigator.userAgent.toLocaleLowerCase().indexOf("miniprogram") <
          0
      ) {
        ///如果是PC端小程序 就不跳转
        let targetUrl = mergeCurrentParams(this.articleInfo.PCUrl);
        let url = URLS.updateSearchParam("markCode", this.markCode, targetUrl);
        window.$sk.goto(url);
        return false;
      }
      if (browerType == "mobile" && location.href.indexOf("wap") < 0) {
        let targetUrl = mergeCurrentParams(this.articleInfo.url);
        let url = URLS.updateSearchParam("markCode", this.markCode, targetUrl);
        window.$sk.goto(url);
        return false;
      }
      return true;
    },
    browse() {
      let param = {
        articleId: articleId,
        sess: this.sess,
        globalUserId: this.globalUserId,
        openId: this.userInfo.user.openId || "",
        url: window.location.href,
        referenceUrl: document.referrer,
        equipment: {},
        pageTitle: this.articleInfo.title,
        weChatId:
          parseInt(this.articleInfo.weChatId) ||
          parseInt(this.articleInfo.authorisedWeChatId) ||
          "",
        resolution: window.screen.width + "*" + window.screen.height,
        markCode: this.markCode,
        marketingSess: ck.cookie("marketingSess") || "",
        taskId: this.taskId
      };
      service.browse(param).subscribe(data => {
        data;
        if (
          this.articleInfo.useLinkUrl == "1" &&
          this.articleInfo.linkUrl !== ""
        ) {
          window.location.replace(this.articleInfo.linkUrl);
          return;
        }
      });
    }
  },
  components: {
    Header,
    Title,
    Content,
    File,
    Comment,
    CommentList,
    Banner,
    Subtitle,
    Thumbs,
    // Card,
    Original,
    OriginSubtitle,
    Cta,
    Card
  }
};
